import { push, replace } from 'connected-react-router';
import { stringifyUrl } from 'query-string';
import { Dispatch } from 'redux';
import { StandardQueryParams } from '../../global/types';
import { PAYOUTS_URL } from '../../global/urls';
import { defaultSortOrder } from './constants';

type QueryParams = StandardQueryParams;

export const getPayoutsUrl = (params: QueryParams): string => {
  const query: QueryParams = {};
  if (params.search) {
    query.search = params.search;
  }
  if (params.sort && params.sort !== defaultSortOrder) {
    query.sort = params.sort;
  }
  if (params.start) {
    query.start = params.start;
  }
  return stringifyUrl({ url: PAYOUTS_URL, query });
};

export const replacePayoutsUrl = (dispatch: Dispatch, params: QueryParams): void => {
  const url = getPayoutsUrl(params);
  dispatch(replace(url, { keepState: true }));
};

export const pushPayoutsUrl = (
  dispatch: Dispatch,
  params: QueryParams,
  keepState = false
): void => {
  const url = getPayoutsUrl(params);
  dispatch(push(url, { keepState }));
};
